<template lang="html">
  <div class="d-inline-flex align-items-center">
    <d-badge
      v-if="showAwaitingApprovalLabel && quotation.status?.slug === 'waiting' && !isAdmin && !isAdmin2"
      theme="secondary"
      class="mr-3"
    >
      <i class="fas fa-clock mr-1"></i> Aguardando aprovação
    </d-badge>
    <d-button-group class="buttons">
      <template v-if="isFinancial && quotation.status_id == 7">
      <quotation-button-approve-payment :quotation="quotation"></quotation-button-approve-payment>
      <d-button class="btn btn-secundary text-uppercase" @click="printQuotation()" >Visualizar orçamento</d-button>
    </template>
    <template v-else>
      <template v-if="quotation.status_id == 2 || quotation.status_id == 5">
        <d-dropdown text="Apresentação" theme="info">
          <a v-if="!isCustomer && quotation.customer" class="dropdown-item" @click="openModal('send_presentation_modal')"
            :disabled="!quotation.customer.email">
            <i class="fas fa-envelope"></i><span class="d-none d-lg-inline"> E-mail</span>
          </a>
          <a v-if="!isCustomer && quotation.customer" class="dropdown-item" @click="openModal('send_whats_presentation_modal')"
            :disabled="!quotation.customer.phone">
            <i class="fab fa-whatsapp"></i><span class="d-none d-lg-inline"> Whatsapp</span>
          </a>
          <a class="dropdown-item">
            <i class="fas fa-print"></i><span class="d-inline">
              <a :href="quotation.class.file.url" target="_blank"> Imprimir</a>
            </span>
          </a>
        </d-dropdown>
      </template>
      <template v-if="quotation.status?.slug === 'approved' || quotation.status?.slug === 'approved-admin' || (quotation.status?.slug === 'waiting' && (isAdmin || isAdmin2))">
        <d-dropdown text="Orçamento" theme="secondary">
          <a v-if="!isCustomer && quotation.customer" class="dropdown-item" @click="openModal('send_quotation_modal')"
            :disabled="!quotation.customer.email">
            <i class="fas fa-envelope"></i><span class="d-none d-lg-inline"> E-mail</span>
          </a>
          <a v-if="!isCustomer && quotation.customer" class="dropdown-item" @click="openModal('send_whats_quotation_modal')"
            :disabled="!quotation.customer.phone">
            <i class="fab fa-whatsapp"></i><span class="d-none d-lg-inline"> Whatsapp</span>
          </a>
          <a v-if="!isCustomer && quotation.customer" class="dropdown-item" @click="printQuotation()">
            <i class="fas fa-print"></i><span class="d-none d-lg-inline"> Imprimir</span>
          </a>
        </d-dropdown>
      </template>
      <template v-if="quotation.status?.slug === 'waiting' && (isAdmin || isAdmin2)" >
        <quotation-button-approve :quotation="quotation"></quotation-button-approve>
      </template>
      <d-dropdown text="Opções" theme="success" v-if="!isCustomer">
        <a class="dropdown-item" @click="assignQuotation()" v-if="!isModel">
          <i class="fas fa-share-square d-xl-none d-xx-inline d-inline"></i><span class="d-none d-lg-none d-xl-inline">
            Atribuir</span>
        </a>
        <a class="dropdown-item" @click="duplicate()">
          <i class="fas fa-copy d-xl-none d-xx-inline d-inline"></i><span class="d-none d-lg-none d-xl-inline">
            Duplicar</span>
        </a>
        <a class="dropdown-item" @click="confirmDeleteRow()">
          <i class="fas fa-trash d-xl-none d-xx-inline d-inline"></i><span class="d-none d-lg-none d-xl-inline">
            Deletar</span>
        </a>
        <a class="dropdown-item" @click="openModal('change_quotation_priority')">
          <i class="fas fa-sort-amount-up d-xl-none d-xx-inline d-inline"></i><span class="d-none d-lg-none d-xl-inline">
            Temperatura</span>
        </a>
      </d-dropdown>
    </template>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import QuotationButtonApprove from '_modules/quotation/components/QuotationButtonApprove.vue';
import QuotationButtonApprovePayment from '_modules/quotation/components/QuotationButtonApprovePayment.vue';
import UserPermissions from '_common/mixins/UserPermissions';
import { catchPdf, downloadWordFile, openUrlInNewTab } from '_utils/require';
import {
  _OPEN_MODAL_,
  _LOAD_MODEL_,
  _OPEN_CONFIRMATION_,
  _OPEN_ASSIGN_MODAL_,
} from '_modules/quotation/components/QuotationModel';

export default {
  name: 'quotation-buttons',
  mixins: [UserPermissions],
  props: {
    quotation: {
      type: Object,
      default: null,
    },
    isModel: {
      type: Boolean,
      default: false,
    },
    showPrintQuotation: {
      type: Boolean,
      default: true,
    },
    showAwaitingApprovalLabel: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    QuotationButtonApprove,
    QuotationButtonApprovePayment,
  },
  computed: {
    isFinancial() {
      const { user } = this.$store.state.user;
      if (user.settings.role_id === 1) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      isCustomer: false,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'checkIsCustomer',
    ]),
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { quotation: this.quotation, type: 'delete' });
    },
    duplicate() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.duplicate(this.quotation.id)
        .then(response => {
          this.activeAlert({ message: 'Orçamento duplicado com sucesso', theme: 'success' });
          Events.$emit(_LOAD_MODEL_, response);
          this.$router.push(`/admin/orcamentos/${response.id}`);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    printQuotation() {
      this.validateSlug(this.quotation.type.slug);

      const popUp = openUrlInNewTab(QuotationService.getQuotationPreviewUrl(this.quotation.id));

      if (!popUp) {
        this.activeAlert({ message: 'Bloqueador de pop-up ativo para visualização do orçamento.', theme: 'warning' });
      }
    },
    validateSlug(slug) {
      const valid = ['esportivo', 'decorativo'];

      if (!valid.includes(slug)) {
        this.activeAlert({ message: 'Não há um layout para este tipo de orçamento, usaremos o layout padrão: esportivo', theme: 'warning' });
      }
    },
    openPdf() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.viewPdf(this.quotation.contract.id)
        .then(response => downloadWordFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    openModal(type = 'send_whats_quotation_modal') {
      this.setToggle({ type, bool: true });
      Events.$emit(_OPEN_MODAL_, { quotation: this.quotation, type });
    },
    assignQuotation() {
      this.setToggle({ type: 'assign_quotation_modal', bool: true });
      Events.$emit(_OPEN_ASSIGN_MODAL_, this.quotation);
    },
  },
  mounted() {
    this.checkUser();
  },
};
</script>

<style lang="scss" scoped>
a {
  cursor: pointer;
}
@media (min-width: 1535px) {
  .d{
    &-xx {
      &-inline {
        display: inline!important;
      }
    }
  }
}
</style>
